{
  "filter": {
    "all": "Todos los proveedores",
    "country": "country",
    "direct": "Proveedores directos",
    "indirectConfidential": "Proveedores indirectos, confidenciales",
    "nonConfidential": "Proveedores indirectos, no confidenciales"
  },
  "list": {
    "countContact_one": "{{count}} Contacto",
    "countContact_many": "countContact",
    "countContact_other": "{{count}} Contactos",
    "noAddress": "No se proporcionó dirección",
    "noSuppliers": "No se encontraron proveedores",
    "searchPlaceholder": "Buscar",
    "supplierTypePlaceholder": "Tipo de proveedor"
  },
  "productionSites": {
    "columns": {
      "confidential": "Proveedor confidencial",
      "contactEmail": "Correo electrónico de contacto",
      "country": "País",
      "internalCode": "Código interno",
      "name": "Nombre",
      "parentCompany": "Parent business partner",
      "performedActivities": "Actividades realizadas",
      "registrationId": "IDs de registro del sitio"
    },
    "filters": {
      "searchPlaceholder": "Buscar"
    },
    "search": {
      "placeholder": "placeholder"
    },
    "title": "Sitios de producción"
  },
  "repository": {
    "actions": {
      "delete": "Eliminar",
      "edit": "Editar"
    },
    "create": {
      "error": {
        "message": "The business partner has not been created",
        "title": "Error creating business partner"
      },
      "success": {
        "message": "The business partner has been created successfully",
        "title": "Business partner created"
      }
    },
    "delete": {
      "error": {
        "message": "The business partner has not been deleted",
        "title": "Error deleting business partner"
      },
      "success": {
        "message": "The business partner has been deleted successfully",
        "title": "Business partner deleted"
      }
    },
    "title": "All",
    "update": {
      "error": {
        "message": "The business partner has not been updated",
        "title": "Error updating business partner"
      },
      "success": {
        "message": "The business partner has been updated successfully",
        "title": "Business partner updated"
      }
    }
  },
  "risk": {
    "high": "Alto",
    "low": "Bajo",
    "medium": "Medio",
    "table": {
      "certificationRisk": {
        "title": "title",
        "tooltip": "tooltip"
      },
      "collaborationRisk": {
        "title": "title",
        "tooltip": "tooltip"
      }
    }
  },
  "sort": {
    "averageResponseTime": "averageResponseTime",
    "company": "company",
    "completedProductionSiterequests": "completedProductionSiterequests",
    "completedProductrequests": "completedProductrequests",
    "completedScopeCertificaterequests": "completedScopeCertificaterequests",
    "completedTransactionCertificaterequests": "completedTransactionCertificaterequests",
    "email": "email",
    "lastConnectionDate": "lastConnectionDate",
    "lastReminderDate": "lastReminderDate",
    "name": "name",
    "pendingDocumentrequests": "pendingDocumentrequests",
    "pendingProductionSiterequests": "pendingProductionSiterequests",
    "pendingProductrequests": "pendingProductrequests",
    "pendingScopeCertificaterequests": "pendingScopeCertificaterequests",
    "pendingTransactionCertificaterequests": "pendingTransactionCertificaterequests"
  },
  "subSuppliers": {
    "title": "Mis proveedores"
  },
  "supplier": {
    "averageResponseTime": "Tiempo de respuesta promedio",
    "averageResponseTimeValue_one": "{{nbDays}} día",
    "averageResponseTimeValue_many": "{{nbDays}} días",
    "averageResponseTimeValue_other": "{{nbDays}} días",
    "informationRequests": "Solicitudes de producto",
    "lastConnection": "Última conexión",
    "lastConnectionValue": "Hace {{nbDays}} días",
    "lastReminderSent": "Último correo electrónico enviado",
    "lastReminderSentValue": "Hace {{nbDays}} días",
    "noLastConnection": "Sin conexión aún",
    "noLastReminderSent": "Sin correo electrónico enviado aún",
    "noResponseTime": "Sin respuestas aún",
    "productionSites": "Sitios de producción",
    "scopeCertificates": "Certificados de alcance",
    "transactionCertificates": "Certificados de transacción",
    "transferContact_one": "Transferir {{count}} solicitud\nincompleta a otro contacto",
    "transferContact_many": "transferContact",
    "transferContact_other": "Transferir {{count}} solicitudes\nincompletas a otro contacto",
    "transferContactCertificates_one": "transferContactCertificates",
    "transferContactCertificates_many": "transferContactCertificates",
    "transferContactCertificates_other": "transferContactCertificates",
    "transferModal": {
      "companyCountry": "companyCountry",
      "companyCountryPlaceholder": "companyCountryPlaceholder",
      "companyName": "companyName",
      "companyNamePlaceholder": "companyNamePlaceholder",
      "email": "Correo electrónico",
      "emailPlaceholder": "por ejemplo: juan@empresa.com",
      "name": "Nombre",
      "namePlaceholder": "por ejemplo: Juan Pérez",
      "title": "Transferir contacto",
      "transfer": "Transferir",
      "transferSuccess_one": "transferSuccess",
      "transferSuccess_many": "transferSuccess",
      "transferSuccess_other": "transferSuccess"
    }
  },
  "title": "Socios comerciales"
}
